module.exports = __webpack_public_path__ + "img/verifireDark.1b8b2d41.svg";